import request from "project-config/services/request/request";
import { useEffect, useState } from "react";

export function useTimestamp() {
  const [timestamp, setTimestamp] = useState(Date.now());
  const fetchTimestamp = async () => {
    const { data } = await request.post(
      "/api/rendering/pay/code/getServiceDate"
    );
    setTimestamp(data);
  };
  useEffect(() => {
    fetchTimestamp().catch(console.trace);
  }, []);

  return {
    timestamp,
    fetchTimestamp,
  };
}
